export enum StatusId {
  toDo = 'to_do',
  inProgress = 'in_progress',
  waitingForApproval = 'waiting_for_approval',
  approved = 'approved',
  readyToPublish = 'ready_to_publish',
  published = 'published'
}
